// ======================================================================
// File Name       : UserRegisterUpdate
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, Button, Table } from 'react-bootstrap';
import SelectBox from '../SelectBox';
import { convertNodeGroupToNodeString } from '../../utils/UserUtils';
import { getItemBoxName } from '../../utils/index';
import { MODE, VALIDATE_TYPE, LOCK_TYPE, PASS_STRENGTH_TYPE, DEFAULT_DATE_FORMAT, DORMANT_STATE_CHANGE_FLAG } from '../../constants/index';
import { USER_TYPE, USER_TYPE_LIST, ADMIN_ROLE } from '../../constants/UserConstants';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import FormControlValidate from '../FormControlValidate';
import FormControlPassword from '../FormControlPassword';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { SERVICE_TYPE } from '../../constants/ServiceConstant';
import DateTimeWithValidate from '../DateTimeWithValidate';

class UserRegisterUpdate extends React.Component {
  constructor() {
    super();
    this.validation = this.validation.bind(this);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    const {
      userDetail,
      managementAuthorityList,
      userAttributes,
      groupList,
      childUserList,
      selectedGroupList,
      mode,
      isClosed,
      buttonText,
      handleFormChange,
      onHandleChangeAttribute,
      openOrCloseAttributeArea,
      addGroup,
      showSelectGroupDlg,
      showUserRelation,
      deleteChildUser,
      deleteGroup,
      openOrCloseExtend,
      passwordStrength,
      isLocked,
      showCheckDlg,
      serviceType,
      managementAuthoritySecernId,
      displayUserType,
      recordNumUserGroupRelationUserLoging,
      allGroupList,
      userGroupRelationListUserLoging,
      handleTimeChange,
      loginIdPasswordSendFlag,
      mfaUsageFlag, // Step10.0.0
    } = this.props;
    const listGroupIdSelected = [];
    const managementAuthorityListNotAdminRole = [];
    let groupListCheck = groupList;
    if (allGroupList && allGroupList.length) {
      groupListCheck = allGroupList;
    }
    let roleShow = (
      <Col sm={8}>
        <SelectBox
          valueKey="managementAuthoritySecernId"
          nameKey="managementAuthorityName"
          label="権限ロール"
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
          name="managementAuthoritySecernId"
          required={mode === MODE.NEW_MODE}
          value={userDetail.managementAuthoritySecernId}
          data={managementAuthorityList}
          onChange={handleFormChange}
        />
      </Col>);
    if (managementAuthoritySecernId && managementAuthoritySecernId !== ADMIN_ROLE) {
      let roleName = '';
      let managementAuthoritySecernIdShow = userDetail.managementAuthoritySecernId;
      if (mode === MODE.NEW_MODE) {
        managementAuthoritySecernIdShow = managementAuthoritySecernId;
      }
      if (managementAuthorityList && managementAuthorityList.length) {
        const place = managementAuthorityList.findIndex(o => o.managementAuthoritySecernId === managementAuthoritySecernIdShow);
        if (place !== -1) {
          roleName = managementAuthorityList[place].managementAuthorityName;
        }
      }
      roleShow = (
        <Col sm={8} as={Form.Label}>
          {roleName}
        </Col>
      );
    }
    if (selectedGroupList && selectedGroupList.length) {
      for (const groupListSelect of selectedGroupList) {
        if (groupListSelect.groupSecernId !== '') {
          listGroupIdSelected.push(groupListSelect.groupSecernId);
        }
      }
    }
    this.refsToValidate = [];
    let passwordStrengthType = passwordStrength;
    if (parseInt(userDetail.userType, 10) === USER_TYPE.ADMIN) {
      passwordStrengthType = PASS_STRENGTH_TYPE.STRONG;
    }
    if (userDetail.isUnlock === undefined) {
      userDetail.isUnlock = userDetail.lockState ? 0 : 1;
    }
    const groupListView = selectedGroupList && selectedGroupList.map((group, index) => {
      const pos = groupList.findIndex(x => x.groupSecernId === group.groupSecernId);
      return (
        <Form.Group key={index} className="form-info" controlId="formInlineName">
          <Col as={Form.Label} sm={3}>
            所属ユーザーグループ {index + 1}
          </Col>
          <Col sm={5} as={Form.Label} className="padding-left-clear">
            {convertNodeGroupToNodeString(group.groupSecernId, groupListCheck)}
          </Col>
          <Col sm={2} className="button-form">
            <Button
              variant="primary"
              onClick={showSelectGroupDlg.bind(this, index)}
              style={recordNumUserGroupRelationUserLoging && pos < 0 && group.groupSecernId !== '' ? { display: 'none' } : null}
            >
              グループ選択
            </Button>
          </Col>
          {(!recordNumUserGroupRelationUserLoging ?
            (index !== 0 || (index === 0 && group.groupSecernId !== '') || selectedGroupList.length > 1) :
            (listGroupIdSelected.length > 1 || (listGroupIdSelected.length <= 1
              && group.groupSecernId === '')) && (pos > -1 || group.groupSecernId === '')) &&
              <Col sm={1} className="button-form text-end">
                <Button variant="primary" className="btn-96" onClick={deleteGroup.bind(this, index)}>
                  削除
                </Button>
              </Col>}
        </Form.Group>
      );
    });

    const childUserView = childUserList.map((item, index) =>
      (<tr key={index}>
        <td>
          {item.userName}
        </td>
        <td>
          {item.loginId}
        </td>
        <td className="text-center">
          <i
            role="button"
            className="bi bi-trash"
            onClick={deleteChildUser.bind(this, index)}
          />
        </td>
      </tr>),
    );

    const attributeListView = userAttributes.allKeyNums.map((keyNum, index) =>
      (<Form.Group className="form-info" key={keyNum}>
        <Col
          sm={{
            span: 2,
            offset: 1
          }}
          as={Form.Label}
          className="padding-left-clear">
          自由記述領域 {index + 1}
        </Col>
        <Col sm={8}>
          <FormControl
            type="text"
            maxLength="16384"
            value={userAttributes.byKeyNum[keyNum].userAttribute}
            onChange={onHandleChangeAttribute.bind(this, keyNum)}
          />
        </Col>
      </Form.Group>),
    );
    let isShowCalendar = false;
    if (userDetail.dormantStateChangeFlag && userDetail.dormantStateChangeFlag !== DORMANT_STATE_CHANGE_FLAG.DO_NOT_CHANGE) {
      isShowCalendar = true;
    }
    const requiredClass = mode === MODE.NEW_MODE && <span className="required">&nbsp;(※)</span>;
    return (
      <Col sm={12} className="margin-top-10">
        <Form onSubmit={(e) => {e.preventDefault(); showCheckDlg();}} className='form-horizontal'>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              ユーザー名
              <span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={8}>
              <FormControlValidate
                required
                label="ユーザー名"
                maxLength="40"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                type="text"
                name="userName"
                value={userDetail.userName}
                onChange={handleFormChange}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              ログインID
              <span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={8}>
              <FormControlValidate
                required
                type="text"
                label="ログインID"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                name="loginId"
                onChange={handleFormChange}
                value={userDetail.loginId}
                // Step 7.0 #6 START
                validateType={VALIDATE_TYPE.USER_LOGIN_ID}
                // Step 7.0 #6 END
                // #7483 START
                maxLength="256"
                // #7483 END
                messageError={MessageTemplate.MSG_ID_INVALID}
                messageSuccess={MessageTemplate.MSG_ID_VALID}
              />
            </Col>
          </Form.Group>
          {/* List Group */}
          {groupListView}
          {/* End List Group */}
          <Form.Group className="form-info">
            <Col sm={12} className="button-form text-center margin-bottom-8">
              <Button variant="primary" onClick={addGroup.bind(this)}>
                所属グループ追加
              </Button>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              {/* Step10.0.0 START */}
              メールアドレス{" "}
              {mfaUsageFlag ? <span className="required">&nbsp;(※)</span> :''}
              {/* Step10.0.0 END */}
            </Col>
            <Col sm={8}>
              <FormControlValidate
                type="text"
                label="メールアドレス"
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                name="mailAddress"
                value={userDetail.mailAddress || ''}
                validateType={VALIDATE_TYPE.EMAIL}
                onChange={handleFormChange}
                messageError={MessageTemplate.MSG_EMAIL_INVALID}
                messageSuccess={MessageTemplate.MSG_EMAIL_VALID}
                required={loginIdPasswordSendFlag || mfaUsageFlag} // Step10.0.0
              />
            </Col>
          </Form.Group>
          {parseInt(userDetail.userType, 10) === USER_TYPE.GUARDIAN &&
            <Form.Group className="margin-top-20 form-info">
              <Col as={Form.Label} sm={3}>
                閲覧対象ユーザー
              </Col>
              <Col sm={8} className="button-form margin-bottom-10">
                <Button
                  variant="primary"
                  onClick={showUserRelation}
                >
                  ユーザー選択
                </Button>
              </Col>
              <Col sm={12}>
                <Table striped hover className="margin-bottom-clear">
                  <thead>
                    <tr>
                      <th>ユーザー名</th>
                      <th>ログインID</th>
                      <th width="150">操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    {childUserView}
                  </tbody>
                </Table>
              </Col>
            </Form.Group>}
          {mode === MODE.EDIT_MODE && userDetail.lockState === 1 &&
            <Form.Group className="form-info" controlId="formHorizontalLoginID">
              <Col as={Form.Label} sm={3}>
                ロック状態
              </Col>
              <Col as={Form.Label} sm={9}>
                {getItemBoxName(LOCK_TYPE, userDetail.lockState)}
              </Col>
              { userDetail.lockState === 1 &&
              <Col
                as={Form.Label}
                sm={{
                  span: 3,
                  offset: 3
                }}>
                <Form.Check
                  type='checkbox'
                  name="isUnlock"
                  id="isUnlock"
                  checked={userDetail.isUnlock}
                  onChange={handleFormChange}
                  label='ロックを解除する'></Form.Check>
              </Col>}
            </Form.Group>}
          {!isNaN(userDetail.userType) &&
          parseInt(userDetail.userType, 10) === USER_TYPE.STUDENT &&
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              稼働状態
            </Col>
            <Col sm={2}>
              <SelectBox
                name="dormantState"
                value={userDetail.dormantState}
                data={SELECT_BOX_DATA.DORMANT_STATE}
                onChange={handleFormChange}
              />
            </Col>
          </Form.Group>}
          {!isNaN(userDetail.userType) &&
          parseInt(userDetail.userType, 10) === USER_TYPE.STUDENT &&
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={5} className="padding-top-clear padding-bottom-clear margin-top-5">
              <Form.Check
                type='checkbox'
                name="dormantStateChangeFlag"
                id="dormantStateChangeFlag"
                onChange={handleFormChange}
                checked={parseInt(userDetail.dormantStateChangeFlag, 10) !== DORMANT_STATE_CHANGE_FLAG.DO_NOT_CHANGE}
                label='指定した日にちに稼動状態を変更する'></Form.Check>
            </Col>
          </Form.Group>}
          {!isNaN(userDetail.userType) &&
          parseInt(userDetail.userType, 10) === USER_TYPE.STUDENT && isShowCalendar &&
          <Form.Group className="form-info">
            <Col>
            <Col as={Form.Label} sm={3} className="padding-left-37">
              変更日
            </Col>
            <Col sm={3}>
              <DateTimeWithValidate
                dateFormat={DEFAULT_DATE_FORMAT}
                label="変更日"
                value={userDetail.dormantStateChangeDate}
                onChange={date =>
                  handleTimeChange(
                    'dormantStateChangeDate', date,
                  )}
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                disableIncludeToDay
                required
              />
            </Col>
            {/* #7406 START */}
            <Col as={Form.Label} sm={12} className="margin-top-10">
              <div className="required padding-left-20">指定した日にちに稼働状態を変更をする場合は、</div>
              <div className="required padding-left-20">上記にある「稼働状態」の変更を同時に設定しないでください。</div>
              <div className="required padding-left-20">(二重に変更され、元の稼働状態に戻ります)</div>
            </Col>
            </Col>
            {/* #7406 END */}
          </Form.Group>}
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={5} className="padding-top-clear padding-bottom-clear margin-top-5">
              <Form.Check
                type='checkbox'
                name="passwordChangeFlag"
                id="passwordChangeFlag"
                onChange={handleFormChange}
                checked={parseInt(userDetail.passwordChangeFlag, 10) === 1}
                label='次回ログイン時にパスワード変更'></Form.Check>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={5} className="padding-top-clear padding-bottom-clear margin-top-5">
              <Form.Check
                type='checkbox'
                name="loginIdPasswordSendFlag"
                id="loginIdPasswordSendFlag"
                onChange={handleFormChange}
                label='ログインID、パスワードをメールで送信する'></Form.Check>
              <span className="required padding-left-20" hidden={!loginIdPasswordSendFlag}>
                メール送信のために、メールアドレスを入力してください。
              </span>
            </Col>
          </Form.Group>
          <Form.Group className="form-info margin-top-20">
            <Col sm={3} as={Form.Label}>
              <a role="presentation" className={buttonText} onClick={openOrCloseAttributeArea}>
              自由記述領域
              </a>
            </Col>
          </Form.Group>
          <input type="submit" hidden />
          {!isClosed && attributeListView}
        </Form>
      </Col>
    );
  }
}

export default UserRegisterUpdate;
